import React, { Component } from "react";
import TopBar from "../../LayOut/TopBar";
import MiddleBody from "../../LayOut/MiddleBody";
import LeftMenu from "../../LayOut/LeftMenu";
import TopRightMenu from "../../LayOut/TopRightMenu";

export default class ComteleSmsReportView extends Component {
  render() {
    return (
      <>
        <div
          id="5"
          className="col-1"
          style={{
            paddingLeft: "0 !important",
            margin: "0 auto",
            paddingTop: "8px",
          }}
        >
          <LeftMenu />
        </div>

        <div id="6" className="col-8 supMiddle" style={{ zIndex: "1000" }}>
          <TopBar module="comtelesmsreport" history={this.props.history} />
          <MiddleBody
            module="comtelesmsreport"
            middleLarge={true}
            history={this.props.history}
          />
        </div>
        <div id="7" className="col-3">
          <TopRightMenu history={this.props.history} />
        </div>
      </>
    );
  }
}
